// extracted by mini-css-extract-plugin
module.exports = {"container":"_2gDTobYfIubyH9JIyUagXh","restaurantsList":"_1GcCS5ba4wKMHyn_jL8oKn"};